import { render, staticRenderFns } from "./add-case.vue?vue&type=template&id=0732cbae&scoped=true&"
import script from "./add-case.vue?vue&type=script&lang=js&"
export * from "./add-case.vue?vue&type=script&lang=js&"
import style0 from "./add-case.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./add-case.vue?vue&type=style&index=1&id=0732cbae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0732cbae",
  null
  
)

export default component.exports